import React, { useEffect, useMemo, useState, useContext } from 'react';
import moment from 'moment';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import TabPanel from '../../components/TabPanel';
// Component
import Filter from './components/Filter';
import Table from './components/Table';
// API
import {
  postProductInventoryBalanceList,
  postProductInventoryBalanceExport,
} from '../../api/productAllocationApi';
// Context
import AppConst from '../../components/AppLayout/const';
import useInventoryBalanceContext from './context/useInventoryBalanceContext';

let cancelRequest;

export default function ProductInventoryBalancev2() {
  const defaultFilter = {
    team: { label: 'ALL', value: null },
    group: { label: 'ALL', value: null },
    product: { label: 'ALL', value: null },
    date_from: moment().format('YYYY-MM-01'),
    date_to: moment().format('YYYY-MM-DD'),
  };

  const { onSetTitle } = useContext(AppConst.AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [inventoryBalance, setInventoryBalance] = useState([]);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateFilter = async (clear = null) => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }
      cancelRequest = axios.CancelToken.source();

      setLoading(true);
      let request;
      if (clear === 'reset') {
        request = {
          team: defaultFilter?.team?.value,
          group: defaultFilter?.group?.value,
          product: defaultFilter?.product?.value,
          from: defaultFilter?.date_from,
          to: defaultFilter?.date_to,
        };
      } else {
        request = {
          team: filterForm?.team?.value,
          group: filterForm?.group?.value,
          product: filterForm?.product?.value,
          from: filterForm?.date_from,
          to: filterForm?.date_to,
        };
      }

      const response = await postProductInventoryBalanceList(request, {
        cancelToken: cancelRequest.token,
      });

      if (response?.data?.code === '200') {
        setInventoryBalance(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleExportInventoryBalance = async () => {
    try {
      toast.loading('Processing request please kindly wait...');

      const request = {
        team: filterForm?.team?.value,
        group: filterForm?.group?.value,
        product: filterForm?.product?.value,
        from: filterForm?.date_from,
        to: filterForm?.date_to,
      };

      const response = await postProductInventoryBalanceExport(request);

      const { code, result } = response.data.response;
      if (code === '200') {
        window.location.href = result;
        toast.success(`Successfully downloaded file: ${response?.data?.response?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilter);
    handleGenerateFilter('reset');
  };

  onSetTitle('Product Sample Inventory Balance Report');

  useEffect(() => {
    handleGenerateFilter();
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <useInventoryBalanceContext.Provider
        value={useMemo(
          () => ({
            loading,
            filterForm,
            defaultFilter,
            inventoryBalance,
            setFilterForm,
            setLoading,
            handleGenerateFilter,
            handleClearFilter,
            handleExportInventoryBalance,
          }),
          [loading, filterForm],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', boxShadow: 3, paddingLeft: 2 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab
                      label='Inventory Balance List'
                      id='inventory-balance-list'
                      aria-controls='inventory-balance-list'
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={activeTab}>
                  <Table />
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </useInventoryBalanceContext.Provider>
    </div>
  );
}
